import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=35a7bbc9&scoped=true"
import script from "./SendMessageModal.vue?vue&type=script&lang=js"
export * from "./SendMessageModal.vue?vue&type=script&lang=js"
import style0 from "./SendMessageModal.vue?vue&type=style&index=0&id=35a7bbc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7bbc9",
  null
  
)

export default component.exports